export const TicketsPage = {
  en: {
    Tickets: 'Tickets',
  },
  uk: {
    Tickets: 'Квитки',
  },
};
